if (!customElements.get('collection-product-card')) {
  class CollectionProductCard extends HTMLElement {
    constructor() {
      super();
      this.selectedProductId = this.getAttribute('data-related-product-id');
      this.selectors = {
        colorSwatch: '[js-color-swatch]',
        colorPreviewImage: '[data-color-item-id]',
        fieldset: 'fieldset',
        activeFieldsets: '.product-form__color-item-options.is-active, .fieldset-color-swatches',
        productForm: 'product-form',
        mainInput: 'input[name="id"]',
        colorInput: 'input[name="Color"]',
        preorderInput: 'input[js-property-preorder]',
        productOptionsWrapper: '[js-options]',
        quickAddTrigger: '.js-trigger-atc',
        mobileFormShowTrigger: '.js-mobile-form-show',
        mobileFormShowTriggerWrapper: '.js-mobile-form-show-wrapper',
        productImages: '.product-card__alt-media .product-card__slide',
        badgeContainer: '.card-product-badges'
      };

      this.addEventListener('change', this.onVariantChange.bind(this));
    }

    onVariantChange(e) {
      this.updateOptions();
      this.updateMasterId();
      this.removeErrorMessage();

      if (!this.currentVariant) {
        return;
      }

      this.updateVariantInput();

      this.updateVariantPreorderProperty(e);

      if (e?.target?.closest(this.selectors.quickAddTrigger)) {
        this.handleQuickAddTrigger(e);
      }
    }

    connectedCallback() {
      this.querySelectorAll(this.selectors.colorSwatch).forEach((swatch) => {
        swatch.addEventListener('click', this.handleSwatchChange.bind(this));

        swatch.addEventListener('keydown', (e) => {
          if (e.key === ' ' || e.key === 'Enter' || e.key === 'Spacebar') {
            e.preventDefault();
            e.target.click();
          }
        });
      });

      this.querySelectorAll(this.selectors.productImages).forEach((image) => {
        image.addEventListener('click', () => {
          let selectedImages = JSON.parse(sessionStorage.getItem('selectedImageIds')) || [];
          let clickedImageId = image.getAttribute('id');
          let clickedPrefix = clickedImageId.split('-')[0] + '-' + clickedImageId.split('-')[1];
          selectedImages = selectedImages.filter((id) => !id.startsWith(clickedPrefix));
          selectedImages.push(clickedImageId);
          sessionStorage.setItem('selectedImageIds', JSON.stringify(selectedImages));
        });
      });

      let selectedImages = JSON.parse(sessionStorage.getItem('selectedImageIds'));
      const navigationEntries = performance.getEntriesByType('navigation');
      const isBackNavigation = navigationEntries.length > 0 && navigationEntries[0].type === 'back_forward';

      if (selectedImages && selectedImages.length > 0 && isBackNavigation) {
        selectedImages.forEach((imageId) => {
          let selectedImage = document.getElementById(imageId);
          if (selectedImage) {
            selectedImage.scrollIntoView({ behavior: 'smooth' });
            // Clear stored images once we've scrolled to them
            sessionStorage.removeItem('selectedImageIds');
          }
        });
      } else if (!isBackNavigation) {
        // Clear stored images if this is a fresh navigation
        sessionStorage.removeItem('selectedImageIds');
      }

      this.querySelector(
        this.selectors.mobileFormShowTrigger
      )?.addEventListener('click', (e) => {
        e.target
          .closest(this.selectors.mobileFormShowTriggerWrapper)
          ?.classList.add('hidden');
        this.querySelector(this.selectors.productForm)?.classList.add(
          'is-visible'
        );
      });

      let images = null;
      if(window.innerWidth < 550) {
        images = this.querySelectorAll('img.mobile-main-image[loading="lazy"]')
      } else {
        images = this.querySelectorAll('img.desktop-main-image[loading="lazy"]')
      }
      this.handleImageLoading(images);
    }

    handleImageLoading(images) {
      function handleIntersection(entries) {
        entries.map((entry) => {
          if (entry.isIntersecting) {
            entry.target.removeAttribute('loading')
            observer.unobserve(entry.target)
          }
        });
      }

      let options = {
        rootMargin: "400px 0px",
        threshold: 0,
      };

      const observer = new IntersectionObserver(handleIntersection, options);
      images.forEach(image => observer.observe(image));
    }

    handleQuickAddTrigger(e) {
      e.target.checked = false;
      this.querySelector('form')?.querySelector('[type="submit"]')?.click();
    }

    handleSwatchChange(e) {
      const productId = e.target.getAttribute('data-related-product-id');
      const swatches = e.target
        .closest(this.selectors.fieldset)
        ?.querySelectorAll(this.selectors.colorSwatch);
      const colorInput = this.querySelector(this.selectors.colorInput);
      const priceEl = this.querySelector('.price');
      const url = e.target.getAttribute('data-href');
      const price = e.target.getAttribute('data-price');
      const compareAtPrice = e.target.getAttribute('data-compare-price');
      const colorSwatch = e.target.closest('[js-color-swatch]');

      // Update price display
      if (priceEl && price) {
        // Helper function to extract numeric value from formatted price string
        const parsePriceValue = (priceStr) => {
          if (!priceStr || priceStr.trim() === '') return 0;
          // Remove all non-numeric characters except decimal point
          const cleaned = priceStr.replace(/[^\d.,]/g, '');
          // If there's a comma,
          const withoutCommas = cleaned.replace(/,/g, '');
          return parseFloat(withoutCommas) || 0;
        };
        
        const priceNum = parsePriceValue(price);
        const compareAtPriceNum = parsePriceValue(compareAtPrice);
        
        if (compareAtPrice && compareAtPrice.trim() !== '' && compareAtPriceNum > priceNum) {
          // Show sale price
          priceEl.classList.add('price--on-sale');
          
          // Update compare-at-price (crossed out price) in .price__sale
          const compareAtPriceEl = priceEl.querySelector('.price__sale s.price-item--regular');
          if (compareAtPriceEl) {
            compareAtPriceEl.innerHTML = compareAtPrice;
          }
          
          // Update sale price
          const salePriceEl = priceEl.querySelector('.price__sale .price-item--sale');
          if (salePriceEl) {
            salePriceEl.innerHTML = price;
          }
        } else {
          // Show regular price
          priceEl.classList.remove('price--on-sale');
          
          // Update regular price in .price__regular
          const regularPriceEl = priceEl.querySelector('.price__regular .price-item--regular');
          if (regularPriceEl) {
            regularPriceEl.innerHTML = price;
          }
        }
      }

      // set active class on swatch
      swatches.forEach((swatch) => {
        swatch.classList.remove('is-active');
      });

      e.target.classList.add('is-active');
      this.updatesSelectedProductId(productId);

      // Add to user clicked collection swatches
      if (window.selectedCollectionSwatches) {
        const cardProductId = this.getAttribute('data-related-product-id');
        const existingIndex = window.selectedCollectionSwatches.findIndex(item => item.swatchId === cardProductId);
        if (existingIndex !== -1) {
          // Update existing entry if swatchId already exists
          window.selectedCollectionSwatches[existingIndex].swatchElement = e.target;
        } else {
          // Add new entry if swatchId doesn't exist yet
          window.selectedCollectionSwatches.push({
            "swatchId": `collection-product-card[data-related-product-id="${cardProductId}"]`,
            "swatchElement": `span[data-related-product-id="${productId}"]`
          });
        }
      }

      if (colorInput) {
        colorInput.value = e.target.getAttribute('data-value');
      }

      this.onVariantChange();
      this.updateMedia();

      if (url) {
        this.updateLinks(url);
      }

      // Change product title
      if (colorSwatch) {
        const productTitleLink = colorSwatch.closest('.product-card__information').querySelector('.full-unstyled-link');
        if (productTitleLink) {
          const newTitle = colorSwatch.getAttribute('data-product-title');
          if (newTitle) {
            productTitleLink.innerText = newTitle;
          }
        }
      }
      // final sale test
      const finalSale = colorSwatch.getAttribute('data-final-swatch') === 'true';
      const productCardContent = colorSwatch.closest('.product-card__content');
      if (productCardContent) {
        const finalSaleText = productCardContent.querySelector('.final-sale-text');
        if (finalSaleText) {
          if (finalSale) {
            finalSaleText.classList.remove('hide');
            finalSaleText.innerHTML = window.finalSale?.message || "FINAL SALE";
          } else {
            finalSaleText.classList.add('hide');
            finalSaleText.innerHTML = "";
          }
        }
      }

      // Update badge
      this.updateBadge(colorSwatch);
    }

    updateBadge(colorSwatch) {
      let badgeContainer = this.querySelector(this.selectors.badgeContainer);
      const productCardInner = this.querySelector('.product-card__inner');
      
      // Create badge container if it doesn't exist
      if (!badgeContainer && productCardInner) {
        badgeContainer = document.createElement('div');
        badgeContainer.className = 'card-product-badges';
        // Insert at the beginning of product-card__inner
        productCardInner.insertBefore(badgeContainer, productCardInner.firstChild);
      }

      if (!badgeContainer) {
        return;
      }

      const allVariantsPreorder = colorSwatch.getAttribute('data-all-variants-preorder') === 'true';
      const productBadgesJson = colorSwatch.getAttribute('data-product-badges');

      // Clear existing badges
      badgeContainer.innerHTML = '';

      // Add preorder badge if all variants are preorder
      if (allVariantsPreorder) {
        const preorderBadge = document.createElement('span');
        preorderBadge.className = 'card-product-badge card-product-badge-preorder';
        preorderBadge.style.cssText = '--text-color: #929290; --fill-color: transparent;';
        preorderBadge.textContent = 'Preorder';
        badgeContainer.appendChild(preorderBadge);
      } else if (productBadgesJson) {
        // Add custom product badges
        try {
          const productBadges = JSON.parse(productBadgesJson);
          if (Array.isArray(productBadges) && productBadges.length > 0) {
            productBadges.forEach((badge) => {
              const badgeEl = document.createElement('span');
              badgeEl.className = 'card-product-badge custom-card-product-badge';
              badgeEl.style.cssText = `--text-color: ${badge.plp_text_color || '#929290'}; --fill-color: ${badge.plp_fill_color || 'transparent'};`;
              badgeEl.textContent = badge.badge_text || '';
              badgeContainer.appendChild(badgeEl);
            });
          }
        } catch (e) {
          console.error('Error parsing product badges:', e);
        }
      }
    }

    updateLinks(url) {
      if (!url) {
        return;
      }

      this.querySelectorAll('a').forEach(link => {
        link.setAttribute('href', url)
      })
    }

    updatesSelectedProductId(id) {
      if (!id) {
        return;
      }

      this.selectedProductId = id;
      const options = this.querySelectorAll(
        this.selectors.productOptionsWrapper
      );

      options.forEach((option) => {
        if (option.getAttribute('data-product-id') == id) {
          option.classList.add('is-active');

          return;
        }

        option.classList.remove('is-active');
      });
    }

    updateOptions() {
      const fieldsets = Array.from(
        this.querySelectorAll(this.selectors.activeFieldsets)
      );

      this.options = fieldsets
        .sort((a, b) => {
          const positionA = Number(a.getAttribute('data-option-position'));
          const positionB = Number(b.getAttribute('data-option-position'));
          return positionA > positionB ? 1 : -1;
        })
        .map((fieldset) => {
          const radios = Array.from(fieldset.querySelectorAll('input'));

          if (radios.length == 1) {
            return radios[0].value;
          }

          return radios.find((radio) => radio.checked)?.value;
        });
    }

    updateMedia() {
      const images = [
        ...this.querySelectorAll(this.selectors.colorPreviewImage),
      ];

      if (!images.length) {
        return;
      }

      const previewImage = images.filter((image) => {
        return (
          image.getAttribute('data-color-item-id') == this.selectedProductId
        );
      });

      if (!previewImage.length) {
        return;
      }

      images.forEach((image) => image.classList.add('hidden'));
      previewImage.forEach((image) => {
        image.classList.remove('hidden');
        const imgContainer = image.querySelector('.product-card__media-list')?.closest('.product-card__alt-media');
        if (imgContainer) {
          const slideItems = imgContainer.querySelectorAll('.product-card__slide');
          if (slideItems.length > 1) {
            const slider = imgContainer.querySelector('.product-card__controls');
            if (slider) {
              slider.querySelectorAll('.product-card__control--prev, .product-card__control--next').forEach((button) => {
                button.removeAttribute('disabled');
              });
            }
          }
        }
      });
    }

    removeErrorMessage() {
      const productForm = this.querySelector(this.selectors.productForm);
      if (productForm) productForm.handleErrorMessage();
    }

    updateMasterId() {
      this.currentVariant = this.getVariantData().find((variant) => {
        return !variant.options
          .map((option, index) => {
            return this.options[index] === option;
          })
          .includes(false);
      });
    }

    updateVariantInput() {
      const productForm = this.querySelector(this.selectors.productForm);
      const input = productForm.querySelector(this.selectors.mainInput);
      input.value = this.currentVariant.id;
      // input.dispatchEvent(new Event('change', { bubbles: true }));
    }

    updateVariantPreorderProperty(e) {
      const productForm = this.querySelector(this.selectors.productForm);
      const variantInput = e?.target
        || this.querySelector('.product-form__color-item-options.is-active input:checked')
        || this.querySelector('.product-form__color-item-options.is-active input');
      const productPreOrder = productForm.querySelector(this.selectors.preorderInput);

      if (!variantInput) return;

      if (productPreOrder) {
        // Get variant preorder data-attributes
        const datav = variantInput.dataset.variantmeta;
        const datavc = variantInput.dataset.variantcheckoutmeta;

        if(datav !== ""){
          productPreOrder.setAttribute('name', window.variantStrings.preorderProperty);
          productPreOrder.value = datavc;
        } else if (productPreOrder.hasAttribute('name')) {
          productPreOrder.removeAttribute('name');
        }
      }
    }

    getVariantData() {
      this.variantData =
        this.variantData ||
        JSON.parse(this.querySelector('[type="application/json"]').textContent);

      return this.variantData[0][this.selectedProductId] || this.variantData;
    }
  }

  customElements.define('collection-product-card', CollectionProductCard);
}
